module.exports = __webpack_public_path__ + "static/media/front.c160f746.jpg";